import { Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { Box, Grid, styled, Card } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { BiFilterAlt } from 'react-icons/bi';
import {
  WsButton,
  WsDialog,
  WsColors,
  SearchBar,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
} from 'wisestep-base';

import TasksAdvanceFilterFormProps from '../../../../components/filters/models/TasksAdvanceFiltersFormProps';
import WsTasksAdvanceFilter from '../../../../components/filters/taskFilter';
import { WsTaskCreationCard } from '../../../../components/WsTaskCreationCard';

import DueDateTimeFilter from './DueDateTimeFilter';

const FilerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  flexWrap: 'wrap',
}));
export interface TaskSearchRequestProps {
  query?: string;
  timePeriod: string;
  customTime: string;
  sort: string;
}

export interface JobsCrmSearchProps {
  onSearch: (data: TaskSearchRequestProps) => void;
  onApplyFilters: (data: TasksAdvanceFilterFormProps) => void;
  clearAdvanceFilters: () => void;
  advancedFilterDefaultValues: TasksAdvanceFilterFormProps;
}

const TaskSearch = ({
  onSearch,
  onApplyFilters,
  clearAdvanceFilters,
  advancedFilterDefaultValues,
}: JobsCrmSearchProps) => {
  const methods = useForm<TaskSearchRequestProps>({
    defaultValues: {
      sort: 'created_on,desc',
    },
  });
  const { handleSubmit, reset, setValue } = methods;
  const [openFilters, setOpenFilters] = useState(false);
  const [createTask, setCreateTask] = useState(false);
  const StyledCard = styled(Card)({
    p: 0.5,
    height: 40,
    minWidth: '100%',
    display: 'flex',
    alignItems: 'center',
  });

  const clearAllFields = () => {
    reset({ sort: 'created_on,desc', query: '', timePeriod: '', customTime: '' });
    clearAdvanceFilters();
  };

  const onSearchSubmit = (data: TaskSearchRequestProps) => onSearch(data);

  return (
    <Box bgcolor={WsColors.White} borderRadius={1} px={2} py={1} mt={1}>
      <FormProvider {...methods}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <StyledCard elevation={1}>
              <SearchBar
                name="query"
                placeholder="Search for Candidate, Skill, Job Title, Location"
              />
            </StyledCard>
            <WsButton variant="outlined" onClick={clearAllFields}>
              Clear
            </WsButton>
            <WsButton
              variant="contained"
              startIcon={<Search />}
              onClick={handleSubmit(onSearchSubmit)}
            >
              Search
            </WsButton>
          </Box>
          <Box display="flex" alignItems="center" gap={2}>
            <WsButton
              variant="outlined"
              startIcon={<BiFilterAlt />}
              onClick={() => setOpenFilters(true)}
            >
              Advanced filters
            </WsButton>
            <WsButton startIcon={<AddIcon />} onClick={() => setCreateTask(true)}>
              Add Reminder
            </WsButton>
          </Box>
        </Box>
        <FilerBox>
          <Box display="flex" alignItems="center" gap={1}>
            <Grid item>
              <WsTypography variant={WsTypoVariants.SUB_TITLE} bold color={WsTypoColors.BLACK}>
                Applied Filters
              </WsTypography>
            </Grid>
            <DueDateTimeFilter
              onChange={(selectedDateTime: string) => {
                setValue('timePeriod', selectedDateTime);
              }}
            />
          </Box>
        </FilerBox>
      </FormProvider>
      <WsTasksAdvanceFilter
        open={openFilters}
        onApplyFilters={(data: TasksAdvanceFilterFormProps) => onApplyFilters(data)}
        filterClose={() => setOpenFilters(false)}
        defaultValues={advancedFilterDefaultValues}
      />
      <WsDialog openDialog={createTask}>
        <WsTaskCreationCard closeDialog={() => setCreateTask(false)} />
      </WsDialog>
    </Box>
  );
};

export default TaskSearch;
